import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import CTASection from "@/components/CTASection";
import { BLOG_POSTS } from "@/data/content";

export default function Blog() {
  const [featured, ...rest] = BLOG_POSTS;
  return (
    <>
      <SEO title="Blog & Insights" description="Field notes from senior consultants on SQL Server, PostgreSQL, Azure, HA/DR, data engineering and 24×7 managed operations." />

      <section className="bg-[var(--dm-navy)] text-white">
        <div className="dm-container py-24 lg:py-32">
          <div className="dm-overline text-[var(--dm-emerald)]">Insights</div>
          <h1 className="font-serif text-5xl sm:text-6xl mt-6 max-w-4xl leading-[1.05]">Notes from the field — where we've fixed it, and how.</h1>
        </div>
      </section>

      {featured && (
        <section className="bg-white">
          <div className="dm-container dm-section">
            <Link to={`/blog/${featured.slug}`} data-testid={`blog-featured`} className="group grid lg:grid-cols-2 gap-10 items-center">
              <div className="aspect-[16/10] overflow-hidden border border-[var(--dm-border)]">
                <img src={featured.image} alt={featured.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div>
                <div className="dm-overline">{featured.tag} · Featured</div>
                <h2 className="font-serif text-4xl lg:text-5xl mt-4 text-[var(--dm-navy)] leading-tight">{featured.title}</h2>
                <p className="text-[var(--dm-muted)] mt-6 leading-relaxed">{featured.excerpt}</p>
                <div className="mt-6 text-xs text-[var(--dm-muted)] uppercase tracking-[0.18em]">{featured.author} · {featured.date} · {featured.readTime}</div>
                <div className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-[var(--dm-emerald)]">Read the article <ArrowRight className="w-4 h-4" /></div>
              </div>
            </Link>
          </div>
        </section>
      )}

      <section className="bg-[var(--dm-surface)]">
        <div className="dm-container dm-section">
          <div className="dm-overline">Latest articles</div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-8">
            {rest.map((p) => (
              <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group bg-white border border-[var(--dm-border)] hover:border-[var(--dm-navy)]">
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
                </div>
                <div className="p-6">
                  <div className="dm-overline">{p.tag}</div>
                  <div className="font-serif text-xl text-[var(--dm-navy)] mt-3 leading-snug">{p.title}</div>
                  <div className="text-sm text-[var(--dm-muted)] mt-3 leading-relaxed">{p.excerpt}</div>
                  <div className="text-xs text-[var(--dm-muted)] mt-4 uppercase tracking-[0.18em]">{p.date} · {p.readTime}</div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
